import { Routes } from '@angular/router';

import { SignInComponent } from '@features/auth/pages/sign-in/sign-in.component';

import { AppPaths, PAGE_TITLES } from '@core/constants';
import { authGuard, loginGuard } from '@core/guards';

export const routes: Routes = [
    { path: '', redirectTo: '/' + AppPaths.searchPlants, pathMatch: 'full' },
    {
        path: AppPaths.login,
        component: SignInComponent,
        canActivate: [loginGuard],
    },
    {
        path: '',
        loadComponent: () => import('@layout/app-layout/app-layout.component').then((m) => m.AppLayoutComponent),
        canActivate: [authGuard],
        children: [
            {
                path: AppPaths.searchPlants,
                title: PAGE_TITLES.mainTitle + ' - ' + PAGE_TITLES.searchPlants,
                loadComponent: () =>
                    import('@features/plants/pages/search-plant/search-plant.component').then(
                        (m) => m.SearchPlantComponent
                    ),
            },
            {
                path: AppPaths.searchPlantResult,
                title: PAGE_TITLES.mainTitle + ' - ' + PAGE_TITLES.plantResults,
                loadComponent: () =>
                    import('@features/plants/pages/search-plant-result/search-plant-result.component').then(
                        (m) => m.SearchPlantResultComponent
                    ),
            },
            {
                path: AppPaths.searchSuppliers,
                title: PAGE_TITLES.mainTitle + ' - ' + PAGE_TITLES.searchSuppliers,
                loadComponent: () =>
                    import('@features/suppliers/pages/search-supplier/search-supplier.component').then(
                        (m) => m.SearchSupplierComponent
                    ),
            },
            {
                path: AppPaths.searchSupplierResult,
                title: PAGE_TITLES.mainTitle + ' - ' + PAGE_TITLES.supplierResults,
                loadComponent: () =>
                    import('@features/suppliers/pages/search-supplier-result/search-supplier-result.component').then(
                        (m) => m.SearchSupplierResultComponent
                    ),
            },
            {
                path: AppPaths.dataManagement,
                title: PAGE_TITLES.mainTitle + ' - ' + PAGE_TITLES.dataManagement,
                loadComponent: () =>
                    import('@features/data-management/pages/data-management/data-management.component').then(
                        (m) => m.DataManagementComponent
                    ),
            },
        ],
    },
    {
        path: '**',
        redirectTo: '/' + AppPaths.searchPlants,
    },
];
